// Vendor imports
const { connect } = require('react-redux')
// Common client-v2 imports
const deferDispatch = require('client-v2/common/state/dispatch')
// Entry imports
const modalActions = require('./actions')
const AuthModal = require('./component-dumb')
const socialProviders = require('./providers')

function mapStateToProps(state) {
  const { authModal } = state
  if (!authModal) {
    return { socialProviders }
  }
  return {
    hasAccount: authModal.hasAccount,
    isVisible: authModal.isVisible,
    socialProviders
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    onClose: dispatchAction(modalActions.hide),
    onHasAccountToggle: dispatchAction(modalActions.show),
    onSocialProviderAuth: dispatchAction(modalActions.socialAuth)
  }
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(AuthModal)
